import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../icons/Icons';
import Button from '../../sharedComponents/Button';

const EditTemplate = ({ children, status, header, onConfirmClick, onCancelClick, label }) => (
    <React.Fragment>
        {header}
        <div className="rec-edit-wrap">
            {children}
            <div>
                {status}
                <Button
                    appearance="secondary"
                    className="rec-apply-updates"
                    onClick={onConfirmClick}
                    iconBeforeElement={<Icons.IconCheck />}
                    screenReaderTextBefore={label ? `Apply edits to ${label} content` : 'Apply edits'} />
                <Button
                    appearance="danger"
                    className="rec-cancel-updates"
                    onClick={onCancelClick}
                    iconBeforeElement={<Icons.IconClose />}
                    screenReaderTextBefore={label ? `Cancel edits to ${label} content` : 'Cancel edits'} />
            </div>
        </div>
    </React.Fragment>
);

EditTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.string,
        PropTypes.node
    ]),
    status: PropTypes.element,
    header: PropTypes.element,
    onConfirmClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired
};

EditTemplate.defaultProps = {
    status: null,
    children: null
};

export default EditTemplate;
